<section class="flock-overview-week-registration-detailed spacing--margin-half-top">
  <mat-select
    class="flock-overview-week-registration-detailed__sort-by"
    [hideSingleSelectionIndicator]="true"
    data-test="flock-overview-week-registration-detailed__sortBy"
    [value]="weekRegistrationSortBy"
    (selectionChange)="onWeekRegistrationSortByChanged($event)"
  >
    <mat-option value="asc">
      {{ 'flock-overview.week-registrations.sortByAscending' | translate }}
    </mat-option>
    <mat-option value="desc">
      {{ 'flock-overview.week-registrations.sortByDescending' | translate }}
    </mat-option>
  </mat-select>

  <div class="flock-overview-week-registration-detailed__table-container">
    <table class="flock-overview-week-registration-detailed__table">
      <thead>
        <tr>
          @for (column of columns; track column.id) {
            <th scope="col">
              @if (column.chartable) {
                <button
                  type="button"
                  class="flock-overview-week-registration-detailed__kpi-header"
                  (click)="openBenchmark(column.kpi)"
                >
                  {{ column.label }}
                </button>
              } @else {
                {{ column.label }}
              }
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track row.week) {
          <tr>
            @for (column of columns; track column.id) {
              <td
                [class.flock-overview-week-registration-detailed__remarks]="column.id === 'remarks'"
              >
                {{ row[column.id] }}
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</section>
